import { initComponentStore, noop } from "@/utils/mobx";


export interface ContextMenuOption {
    title: string;
    value: string;
    isDisabled?: boolean;
}

export class ContextMenuStore {
    options: ContextMenuOption[] | null = null;
    isVisible: boolean = false;
    onClose: (() => any) | null = null;
    onSelect: ((value: string) => any) | null = null;
    className: string | null = null;
    focusedOptionIndex: number | null = null;
    x: number | null = null;
    y: number | null = null;

    constructor() {
        initComponentStore(this);
    }

    show(x: number, y: number, options: ContextMenuOption[], onSelect: (value: string) => void) {
        this.x = x;
        this.y = y;
        this.options = options;
        this.onSelect = onSelect;
        this.setIsVisible(true);
    }

    setIsVisible(value: boolean) {
        this.focusedOptionIndex = null;
        this.isVisible = value;
    }

    keyDown(e: KeyboardEvent) {
        if (e.key === "ArrowDown") {
            this.focusedOptionIndex = Math.min(
                (this.focusedOptionIndex !== null ? this.focusedOptionIndex : -1) + 1,
                (this.options || []).length - 1
            );
        } else if (e.key === "ArrowUp") {
            this.focusedOptionIndex = Math.max(
                (this.focusedOptionIndex !== null ? this.focusedOptionIndex : -1) - 1,
                0
            );
        } else if (
            (e.key === "Enter" || e.key === "Tab") &&
            this.focusedOptionIndex !== null &&
            this.focusedOptionIndex < (this.options || []).length
        ) {
            if (this.options) {
                this.selectOption(this.focusedOptionIndex);
            }
        } else {
            return;
        }
    }

    selectOption(index: number) {
        const option = this.options![index];
        if (!option.isDisabled) {
            (this.onSelect || noop)(option.value);
            this.close();
        }
    }

    focusOption(index: number) {
        this.focusedOptionIndex = index;
    }

    close() {
        this.isVisible = false;
        (this.onClose || noop)();
    }
}
